var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Datastore, } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { BannerAlertType } from '@freelancer/ui/banner-alert';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { HeadingType } from '@freelancer/ui/heading';
import { InputType } from '@freelancer/ui/input';
import { Margin } from '@freelancer/ui/margin';
import { FontColor, FontType, FontWeight, TextAlign, TextSize, } from '@freelancer/ui/text';
import { pattern, required } from '@freelancer/ui/validators';
import { CookieService } from '@laurentgoudet/ngx-cookie';
import { map } from 'rxjs/operators';
export var MARKETING_MOBILE_NUMBER_COOKIE = 'SKIP_MARKETING_MOBILE_NUMBER';
var MarketingMobileNumberModalComponent = /** @class */ (function () {
    function MarketingMobileNumberModalComponent(cookies, datastore, fb, modalRef) {
        this.cookies = cookies;
        this.datastore = datastore;
        this.fb = fb;
        this.modalRef = modalRef;
        this.BannerAlertType = BannerAlertType;
        this.ButtonColor = ButtonColor;
        this.ButtonSize = ButtonSize;
        this.FontColor = FontColor;
        this.TextSize = TextSize;
        this.FontType = FontType;
        this.FontWeight = FontWeight;
        this.HeadingType = HeadingType;
        this.InputType = InputType;
        this.Margin = Margin;
        this.TextAlign = TextAlign;
        this.mobileNumberRequiredError = 'Please enter phone number';
        this.mobileNumberInvalidError = 'Please enter a valid phone number';
        this.phoneCodeError = 'Please select a country';
    }
    MarketingMobileNumberModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formGroup = this.fb.group({
            mobileNumber: [
                '',
                [
                    pattern(/^[0-9]*$/, this.mobileNumberInvalidError),
                    required(this.mobileNumberRequiredError),
                ],
            ],
            phoneCode: ['', required(this.phoneCodeError)],
        });
        var countries$ = this.datastore
            .collection('countries')
            .valueChanges();
        this.newCountries$ = countries$.pipe(map(function (countries) {
            _this.initialCountriesList = countries.map(function (country) { return ({
                displayText: country.name + " +" + country.phoneCode,
                value: country,
            }); });
            _this.countriesList = [
                { displayText: '', value: '', disabled: true }
            ].concat(_this.initialCountriesList);
            return countries;
        }));
    };
    MarketingMobileNumberModalComponent.prototype.changeCountry = function (country) {
        this.countriesList = this.initialCountriesList.slice();
        this.countriesList = this.countriesList.map(function (countryObject) {
            return country.id === countryObject.value.id
                ? __assign({}, countryObject, { displayText: country.code + " +" + country.phoneCode }) : countryObject;
        });
    };
    MarketingMobileNumberModalComponent.prototype.handleSkip = function () {
        this.cookies.put(MARKETING_MOBILE_NUMBER_COOKIE, 'skip', {
            expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        });
        this.modalRef.close('closed');
    };
    MarketingMobileNumberModalComponent.prototype.handleSubmit = function () {
        var _this = this;
        this.submissionPromise = this.datastore
            .collection('usersSelf')
            .update(this.userId, {
            marketingMobileNumber: {
                phoneNumber: this.formGroup.controls.mobileNumber.value,
                countryCode: String(this.formGroup.controls.phoneCode.value.phoneCode),
            },
        })
            .then(function (result) {
            if (result.status === 'success') {
                _this.modalRef.close('submit');
            }
            return result;
        });
    };
    return MarketingMobileNumberModalComponent;
}());
export { MarketingMobileNumberModalComponent };
